import React from "react";
import ReactDOM from "react-dom";
import "./loading-dialog.css";
import {ScaleLoader} from "react-spinners";

const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
};

export default function LoadingDialog({ title, loading, onCancel }) {
    return ReactDOM.createPortal(
        <div className="dialog-overlay" onClick={onCancel}>
            <div id="dialog-container" onClick={(e) => e.stopPropagation()}>
                <div id="dialog-title">{title}</div>
                <ScaleLoader loading={loading} color={"white"} size={150} cssOverride={override} />
                <div id="dialog-buttons">
                    <button onClick={onCancel}>Cancel</button>
                </div>
            </div>
        </div>,
        document.body
    );
}
